import $ from 'jquery';

$('#trial-form').each(function() {

    var $form = $(this);

    $form.on('focus change', 'input', function() {
        $(this).tooltip('hide').removeClass('has-error');
    });

    $form.find('input[name="type[]"]').on('change', function() {
        $form.find('input[name="type[]"]').each(function() {
            $(this).tooltip('hide').removeClass('has-error');
        });
    });
    
    $form.submit(e => {

        e.preventDefault();

        if (!validateForm()) {
            return false;
        }

        var data = $form.serializeArray(),
            url = $form.attr('action');

        $.post(url, data, result => {

            if ($form.find('input[value=Testversion]').is(':checked')) {
            
                $form.replaceWith(`<div class="form-success my-lg-5 col-lg-8 mx-auto text-center">
                    <h2>Ihre Anfrage für eine Testversion wurde erfolgreich gesendet</h2>
                    <p>Vielen Dank für die Anforderung einer Testversion von MEDICAL OFFICE.</p>
                    <p>In Kürze erhalten Sie eine E-Mail mit dem Link zum Download. Bitte kontrollieren Sie auch Ihren Spam Ordner.</p>
                    <p>Bei der Testversion handelt es sich um eine Vollversion von MEDICAL OFFICE mit allen verfügbaren Programm-Modulen und einigen Beispielpatienten. Die Medikamentendatenbank, der ICD-Katalog und die Gebührenordnungen EBM und GOÄ sind komplett enthalten, sodass Sie von der Erfassung der Patienten über die Diagnostik und Medikationsvergabe bis zur Abrechnung alle Abläufe der Praxisorganisation durchspielen können.
                    Der einzige Unterschied zur Vollversion von MEDICAL OFFICE besteht darin, dass im Ausdruck und der Abrechnung jeder Patient als „Max Mustermann“ erscheinen wird.
                    Die Nutzung der Testversion ist zeitlich uneingeschränkt möglich.</p>
                </div>`);

            } else {

                $form.replaceWith(`<div class="form-success my-lg-5 col-lg-8 mx-auto text-center">
                    <h2>Ihre Anfrage wurde erfolgreich gesendet</h2>
                    <p>Vielen Dank für die Anfrage.</p>
                    <p>Wir werden uns schnellstmöglich mit Ihnen in Verbindung setzen und einen individuellen Termin vereinbaren.</p>
                </div>`);

            }

            window.setTimeout(e => {
                $('html, body').animate({
                    scrollTop: $('.form-success').offset().top - 300
                }, 500)
            }, 0);

        });


    });

    var validateForm = () => {

        if ($form.find('input[name="type[]"]:checked').length == 0) {
            $form.find('input[name="type[]"]:first').tooltip({
                title: 'Bitte wählen Sie aus, wie Sie MEDICAL OFFICE kennenlernen möchten.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if ($form.find('input[name=company]').val() == '') {
            $form.find('input[name=company]').tooltip({
                title: 'Bitte geben Sie den Namen Ihrer Praxis ein.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if ($form.find('input[name=contact]').val() == '') {
            $form.find('input[name=contact]').tooltip({
                title: 'Bitte geben Sie den Namen Ihres Ansprechpartners ein.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if ($form.find('input[name=street]').val() == '') {
            $form.find('input[name=street]').tooltip({
                title: 'Bitte geben Sie Ihre Straße und Hausnummer ein.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if ($form.find('input[name=city]').val() == '') {
            $form.find('input[name=city]').tooltip({
                title: 'Bitte geben Sie Ihre Postleitzahl und Ort ein.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test($form.find('input[name=email]').val()) == false) {
            $form.find('input[name=email]').tooltip({
                title: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if ($form.find('input[name=phone]').val() == '') {
            $form.find('input[name=phone]').tooltip({
                title: 'Bitte geben Sie Ihre Telefonnummer ein.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }

        if ($form.find('input#check-privacy').is(':checked') == false) {
            $form.find('input#check-privacy').tooltip({
                title: 'Bitte bestätigen Sie, unsere Datenschutzerklärung gelesen zu haben.',
                trigger: 'manual'
            }).tooltip('show').addClass('has-error');
        }
        
        if ($form.find('.has-error').length > 0) {
            $('html, body').animate({
                scrollTop: $form.find('.has-error:first').offset().top - 300
            }, 1000)
        }

        return $form.find('.has-error').length == 0;

    }


});